export const logoutIcon = `
<svg width="100%" height="100%" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="28" height="28"  />
<path d="M10.625 4H6.875C6.37772 4 5.90081 4.20852 5.54918 4.57968C5.19754 4.95085 5 5.45426 5 5.97917V19.8333C5 20.3582 5.19754 20.8616 5.54918 21.2328C5.90081 21.604 6.37772 21.8125 6.875 21.8125H10.625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 18.0625L21.6875 12.9062L17 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21 13H8.8125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
